<template>
    <div>
     <div class="upload-container">
         <div class="common upload-top">
             <p class="top-title">AI审核</p>
             <div class="top-list">
                 <span>文件</span>
                 <span>审核状态</span>
                 <span>审核结果</span>
             </div>
             <div class="upload-list" v-for="(item,index) in fileList" :key="index">
                <div class="upload-list_left"> 
                   <img v-if="item.resourceType=='image'" src="@/assets/img.png" alt="404">
                    <img v-if="item.resourceType=='pdf'" src="@/assets/pdf.png" alt="404">
                    <img v-if="item.resourceType=='video'" src="@/assets/video.png" alt="404">
                    <img v-if="item.resourceType=='audio'" src="@/assets/rec.png" alt="404">
                    <img v-if="item.resourceType=='zip'" src="@/assets/zip.png" alt="404">
                    <span class="file-name">{{item.resourceName}}</span>
                </div>
                <div class="upload-list_right">
                    <img v-if="item.resourceType!='image'&&item.resourceType!='video'&&item.resourceType!='audio'" src="@/assets/success.png" alt="404">
                    <img v-else-if="item.status==1" src="@/assets/interrupt.png" alt="404">
                    <img v-else-if="item.status==2" src="@/assets/success.png" alt="404">
                    <i v-else class="el-icon-loading" />
                </div>

            </div>
             <!-- <p class="top-operate">请上传资源</p> -->
         </div>
         <div class="common upload-bottom">
             <p>温馨提示</p>
             <p>1. 资源审核中，请勿关闭页面，审核完成后将自动进行下一 步操作。</p>
             <p>2. AI会对内容进行涉黄涉政涉暴判定，违规内容将被自动删除，不会进入后续流程，申诉请联系客服。</p>
             <p>3. 如审核时间过长，可点击“在后台审核”，进入转码步骤，系统将在后台完成审核工作。</p>
         </div>
 
     </div>
 
     <div class="upload-btn">
         <div class="check-btnA">
             <span>自动执行中，完成后将进入下一步</span>
         </div>
         <div class="check-btnB" @click="goTranscoding">
            <span>在后台审核</span>
        </div>
     </div>
     <div class="naviPosition" />
     <div class="digNavigate">
       <router-link class="navItm" :to="{ name: 'Waphome' }">
         <img src="../../../images/home.png" class="img-normal">
         <img src="../../../images/home_select.png" class="img-active">
         <label>首页</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Waplist' }">
         <img src="../../../images/res.png" class="img-normal">
         <img src="../../../images/res_select.png" class="img-active">
          <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
       </router-link>
       <router-link class="navItm active" :to="{ name: 'Wapcertified' }">
         <img src="../../../images/upload.jpg" class="img-normal">
         <img src="../../../images/upload_select.jpg" class="img-active">
         <label>上传</label>
       </router-link>
       <router-link class="navItm" :to="{ name: 'Wapuser' }">
         <img src="../../../images/use.png" class="img-normal">
         <img src="../../../images/use_select.png" class="img-active">
         <label>我的</label>
       </router-link>
     </div>
    </div>
 </template>
 <script>
 import {
  aiTask,
  collectionfileAudit,
  collectionResourceRecord
} from '@/api/library'
 import api from "../../../api/home.js";
 export default {
     data(){
         return{
            fileList: [],
            time: null,
            isAutomatic: true,
            isFinish: false,
            nextStatus:2,
            isCheck:true,
            clients:{}
         }
     },
    created(){
      this.requestclient();
    },
    mounted() {
        this.collectionfileAudit()
    },
     methods:{
       //获取应用信息
      requestclient() {
        const that = this;
        api
          .requestclient({ tenantId: this.$store.getters.tenantId })
          .then(r => {
            that.clients = r.data;
          })
          .catch(err => {
            console.log(err);
          });
      },
        goTranscoding(){
             this.isCheck = false;
             this.$router.push({
                path:'/wap/transcoding',
                 query: {
                    collectionId:this.$route.query.collectionId//''// res.data
                }
            })
            
        },
        async collectionfileAudit() {
            const res = await collectionfileAudit({
                ids: this.$route.query.collectionId,
                status: this.nextStatus
            })
            if (res.data) {
                this.collectionResourceRecord()
            }
        },
        async collectionResourceRecord() {
            const res = await collectionResourceRecord({
                ids: this.$route.query.collectionId
            })

            if (res.data != null && res.data.length > 0) {
                this.fileList = res.data[0].aiTaskResourceVOS
                this.timeSend()
            } else {
                this.fileList.forEach(element => {
                element.status = 1
                })
                this.isFinish = true
                this.isAutomatic = false
            }
        },
        timeSend() {
            this.time = setInterval(() => {
                this.aiTask()
            }, 10000)
        },
    async aiTask() {
      const res = await aiTask({
        ids: this.$route.query.collectionId,
        type: 'audit'
      })

      if (res.data != null) {
        if (res.data.length === 0) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          this.fileList.forEach(element => {
            element.status = 1
          })
          this.isFinish = true
          this.isAutomatic = false
          return
        }

        this.fileList.forEach(element => {
          const itemIndex = res.data[0].aiTaskResourceVOS.find(item => {
            return element.resourceId === item.resourceId
          })

          if (itemIndex) {
            element.status = itemIndex.status
          } else {
            element.status = 1
            if (this.isAutomatic) {
              this.isAutomatic = false
            }
          }
        })

        if (res.data[0].status === 2) {
          this.isFinish = true
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          if (this.isAutomatic) {
            this.uploadnext()
             if(this.isCheck){
                this.$router.push({
                    path:'/wap/transcoding',
                    query: {
                        collectionId:this.$route.query.collectionId//''// res.data
                    }
                })
             }
            
          }
        }
      }
    },
    uploadnext() {
      const index = this.fileList.findIndex(element => {
       
        return element.status === 2 || element.status === -1
      })
      if (index === -1) {
        this.$refs.tipall.isOpen('重新上传', `该馆藏下无资源`)
      } else {
        this.$emit('uploadNext')
      }
    },
     },
 }
 </script>
 <style src="@/styles/wap.scss" lang="scss" scoped></style>
 <style scoped lang="scss">
    .upload-list{
       width: 100%;
       font-size: 0.2407rem;
       display:flex;
       justify-content:space-between;
       height:0.8333rem;
       .file-name{
            width: 4.25rem;
            display:inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
           
       }
       .upload-list_left{
           line-height: 0.5556rem;
            display:flex;
            align-items: center;
       }
        .upload-list_right{
           line-height: 0.5556rem;
            display:flex;
            align-items: center;
            margin-right: 0.8333rem;
       }
       .common-img{
           width:0.5926rem;
           height:0.5926rem;
           display: inline-block;
       }
   }
     .upload-container {
         box-sizing: border-box;
         width: 100%;
         /* padding-left: 0.3333rem;
         padding-right: 0.3333rem;
         padding-top: 0.3704rem; */
         padding: 0.3704rem 0.3333rem 0.3241rem 0.3333rem;
         background: #eee;
     }
     
     .flex {
         display: flex;
     }
 
     .common {
         width: 100%;
         background: #FFFFFF;
         box-shadow: 0px 0.0463rem 0.1389rem 0px rgba(0,0,0,0.05);
         border-radius: 0.1111rem;
     }
     .upload-top {
         box-sizing: border-box;
         height: 5.037rem;
         margin-bottom: 0.2778rem;
         padding-left: 0.3704rem;
         padding-top: 0.3704rem;
         padding-right: 0.3704rem;
     }
     .top-title {
         height: 0.4259rem;
         font-size: 0.4444rem;
         font-weight: 700;
         color: #4C70E8;
     }
     .top-list {
         margin-top: 0.4352rem;
         width: 100%;
         height: 0.4074rem;
         border-top: 1px solid #F3F4F9;
         border-bottom: 1px solid #F3F4F9;
         /* padding-left: 1.2593rem;
         padding-right: 0.3704rem; */
     }
     .top-list span {
         font-size: 0.3333rem;
         font-weight: 400;
         color: #7B84A1;
         line-height: 0.4074rem;
         opacity: 0.5;
     }
     .top-list span:first-child{
         margin-right: 3.7685rem;
         margin-left: 1.2593rem;
     }
     .top-list span:last-child{
         margin-left: 0.3056rem;
     }
     .upload-bottom {
         box-sizing: border-box;
         height: 5.037rem;
         padding-left: 0.3704rem;
         padding-right: 0.3704rem;
         font-size: 0.3333rem;
         padding-top: 0.3704rem;
     }
     .upload-bottom p:first-child{
         /* margin-top: 0.3704rem; */
         height: 0.4259rem;
         font-size: 0.4444rem;
         font-weight: 700;
         color: #4C70E8;
     }
     .upload-bottom p:nth-child(2){
         margin-top: 0.463rem;
         height: 0.8889rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
         
     }
     .upload-bottom p:nth-child(3){
         margin-top: 0.3333rem;
         height: 0.8889rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
         
     }
     .upload-bottom p:last-child{
         margin-top: 0.3333rem;
         font-size: 0.3333rem;
         line-height: 0.5185rem;
     }
     .upload-btn {
         width: 100%;
         height: 2.8704rem;
         position: absolute;
         bottom:1.25rem;
         box-sizing: border-box;
         padding: 0.3704rem 0.3333rem 0.3704rem 0.3333rem;
         background: #FFFFFF;
         font-size: 0.3333rem;
         font-weight: 700;
         color: #FFFFFF;
     }
     .check-btnA {
         width: 100%;
         height: 0.9259rem;
         background:  #7B84A1;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
         margin-bottom: 0.2778rem;
     }
     .check-btnB {
         width: 100%;
         height: 0.9259rem;
         background: #4C70E8;
         border-radius: 0.1111rem;
         text-align: center;
         line-height: 0.9259rem;
     }
     .digNavigate {
        border-top:  1px solid #F3F4F9;
     }
 </style>